import { render } from "./SquareGrid.vue?vue&type=template&id=13003134&scoped=true"
import script from "./SquareGrid.vue?vue&type=script&lang=js"
export * from "./SquareGrid.vue?vue&type=script&lang=js"

import "./SquareGrid.vue?vue&type=style&index=0&id=13003134&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13003134"]])

export default __exports__